export * from './useDotAnimatedValues';
